import { StyledEngineProvider, ThemeProvider, alpha, createTheme, darken, styled, useTheme } from "@mui/material/styles";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import GlobalStyles from "@mui/material/GlobalStyles";
import CssBaseline from "@mui/material/CssBaseline";
import { Alert, Autocomplete, Box, Button, Card, CardActionArea, CardContent, Checkbox, CircularProgress, Collapse, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, IconButton as material_IconButton, List, ListItem, ListItemIcon, ListItemText, Menu as material_Menu, MenuItem, Paper, Popover, Step, StepLabel, Stepper, Tab, TableCell, TableSortLabel, Tabs, TextField, Tooltip, Typography, styled as material_styled, useMediaQuery } from "@mui/material";
import Save from "@mui/icons-material/Save";
import Clear from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import Add from "@mui/icons-material/Add";
import react, { createElement, forwardRef, useCallback, useEffect, useId, useRef, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ptBR } from "@mui/x-date-pickers/locales";
import "dayjs/locale/pt-br";
import Delete from "@mui/icons-material/Delete";
import prop_types from "prop-types";
import { CheckCircleOutlineOutlined, CloudUpload, ErrorOutlineOutlined, HelpOutlineOutlined, Info } from "@mui/icons-material";
import Drawer from "@mui/material/Drawer";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AppsOutlined from "@mui/icons-material/AppsOutlined";
import { TabContext, TabPanel, Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab";
import { blue, green, orange, red } from "@mui/material/colors";
import Sort from "@mui/icons-material/Sort";
import Help from "@mui/icons-material/Help";
import axios from "axios";
import Close from "@mui/icons-material/Close";
import ClearOutlined from "@mui/icons-material/ClearOutlined";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import PanTool from "@mui/icons-material/PanTool";
import js_cookie from "js-cookie";
import Switch from "@mui/material/Switch";
import material_FormControlLabel from "@mui/material/FormControlLabel";
import moment from "moment";
import * as __rspack_external_react from "react";
const BUTTON_SHADOW = '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)';
const BUTTON_SHADOW_HOVER = '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)';
const MOBILE = '@media (min-width:0px) and (max-width:840px)';
const baseThemeOptions = {
    cssVariables: true,
    typography: {
        fontFamily: 'Nunito,Roboto,Inter,-apple-system,"Segoe UI","Helvetica Neue",Arial,sans-serif',
        fontSize: 14,
        h1: {
            fontSize: '1.7rem',
            lineHeight: '130%',
            fontWeight: 600,
            [MOBILE]: {
                fontSize: '1.5rem'
            }
        },
        h2: {
            fontSize: '1.5rem',
            lineHeight: '150%',
            fontWeight: 500,
            [MOBILE]: {
                fontSize: '1.2rem'
            }
        },
        h3: {
            fontSize: '1.2rem',
            lineHeight: '160%',
            fontWeight: 500,
            [MOBILE]: {
                fontWeight: 600
            }
        },
        h4: {
            fontSize: '1.1rem',
            lineHeight: '160%',
            fontWeight: 500,
            [MOBILE]: {
                fontSize: '1.1rem'
            }
        },
        h5: {
            fontSize: '0.9rem',
            lineHeight: '100%',
            fontWeight: 600
        },
        h6: {
            fontSize: '0.8rem',
            lineHeight: '150%',
            fontWeight: 600
        }
    },
    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    body2: 'span'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState, theme })=>({
                        fontSize: '0.92rem',
                        borderRadius: '6px',
                        fontWeight: 400,
                        textTransform: 'none',
                        height: '40px',
                        boxShadow: 'none',
                        ...'small' === ownerState.size && {
                            height: '34px'
                        },
                        ...'contained' === ownerState.variant && [
                            'primary',
                            'secondary',
                            'error'
                        ].includes(ownerState.color) && {
                            color: theme.palette.common.white,
                            boxShadow: BUTTON_SHADOW,
                            '&:hover': {
                                boxShadow: BUTTON_SHADOW_HOVER
                            }
                        }
                    })
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    boxShadow: 'none'
                },
                rounded: {
                    borderRadius: '12px'
                },
                outlined: {
                    borderColor: '#E4E7EC'
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '4px'
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                toolbar: {
                    minHeight: '32px'
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                gutters: {
                    paddingLeft: '10px',
                    paddingRight: '10px'
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: '30px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: '0.9rem'
                }
            }
        },
        MuiList: {
            styleOverrides: {
                padding: {
                    paddingTop: 0,
                    paddingBottom: 0
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                adornedEnd: {
                    paddingRight: '0px'
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                option: ({ theme })=>({
                        '&[aria-selected="true"]': {
                            backgroundColor: 'transparent'
                        },
                        '&[aria-selected="true"].Mui-focused, &[aria-selected="true"]:hover': {
                            backgroundColor: theme.palette.action.hover
                        }
                    })
            }
        }
    }
};
const theme_baseThemeOptions = baseThemeOptions;
const theme_theme = createTheme({
    ...theme_baseThemeOptions,
    palette: {
        mode: 'light',
        background: {
            default: '#FBFBFB',
            paper: '#FFFFFF',
            border: '#D9D9D9'
        },
        primary: {
            main: '#0A6FB8',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#4A96D2',
            contrastText: '#FFFFFF'
        },
        error: {
            main: '#F5222D',
            contrastText: '#FFFFFF'
        },
        success: {
            main: '#52C41A',
            contrastText: '#FFFFFF'
        },
        alert: {
            main: '#F44336'
        },
        externo: {
            main: '#143768',
            secondary: '#3570BD'
        },
        text: {
            primary: '#4F4F4F',
            secondary: '#828282'
        },
        indicacao_fala_usuario: {
            primary: '#005CAA'
        },
        balao_chat: {
            primary: '#ECFEDB'
        },
        balao_chat_outro: {
            primary: '#FFFFFF'
        },
        texto_chat: {
            primary: '#000000',
            secondary: '#6E6E6E'
        }
    }
});
const src_theme_theme = theme_theme;
const themeEbserh = createTheme({
    ...theme_baseThemeOptions,
    palette: {
        mode: 'light',
        primary: {
            main: '#97BF29',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#9c9e9f',
            contrastText: '#FFFFFF'
        },
        error: {
            main: '#F5222D',
            contrastText: '#FFFFFF'
        },
        success: {
            main: '#52C41A',
            contrastText: '#FFFFFF'
        },
        text: {
            primary: '#4F4F4F',
            secondary: '#828282'
        },
        externo: {
            main: '#97BF29',
            secondary: '#9c9e9f'
        },
        background: {
            default: '#FBFBFB',
            paper: '#FFFFFF',
            border: '#D9D9D9'
        },
        indicacao_fala_usuario: {
            primary: '#005CAA'
        },
        balao_chat: {
            primary: '#ECFEDB'
        },
        balao_chat_outro: {
            primary: '#FFFFFF'
        },
        texto_chat: {
            primary: '#000000',
            secondary: '#6E6E6E'
        }
    }
});
const theme_themeEbserh = themeEbserh;
const LAYER_ORDER = '@layer theme, base, mui, components, utilities;';
const SttThemeProvider = ({ children, config = {}, enableCssLayer = true })=>{
    const selectedTheme = __rspack_external_react.useMemo(()=>{
        const isEbserh = config?.config_id === 'ebserh' || config?.basename === 'ebserh';
        return isEbserh ? theme_themeEbserh : src_theme_theme;
    }, [
        config?.config_id,
        config?.basename
    ]);
    return /*#__PURE__*/ jsxs(StyledEngineProvider, {
        enableCssLayer: enableCssLayer,
        children: [
            enableCssLayer && /*#__PURE__*/ jsx(GlobalStyles, {
                styles: LAYER_ORDER
            }),
            /*#__PURE__*/ jsxs(ThemeProvider, {
                theme: selectedTheme,
                children: [
                    /*#__PURE__*/ jsx(CssBaseline, {}),
                    children
                ]
            })
        ]
    });
};
const theme_SttThemeProvider = SttThemeProvider;
const StyledButton = styled(Button, {
    shouldForwardProp: (prop)=>![
            'danger',
            'nomarginleft'
        ].includes(prop)
})(({ theme, danger, nomarginleft })=>({
        fontWeight: 400,
        textTransform: 'none',
        height: '40px',
        boxShadow: 'none',
        marginLeft: nomarginleft ? '' : '10px',
        ...danger && {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.error.main,
            '&:hover': {
                backgroundColor: theme.palette.error.light,
                boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'
            }
        },
        '&.MuiButton-containedPrimary': {
            boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
            color: theme.palette.common.white,
            '&:hover': {
                boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'
            }
        },
        '&.MuiButton-outlinedPrimary': {
            color: theme.palette.primary.main,
            border: 'solid 1px',
            borderColor: theme.palette.primary.main
        },
        '&.MuiButton-containedSecondary': {
            boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
            color: theme.palette.common.white,
            '&:hover': {
                boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'
            }
        },
        '&.MuiButton-outlinedSecondary': {
            color: theme.palette.secondary.main,
            border: 'solid 1px',
            borderColor: theme.palette.secondary.main
        },
        '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.37)'
        },
        '&.MuiButton-sizeSmall': {
            height: '34px'
        }
    }));
function SttButton(props) {
    const { danger, nomarginleft, ...otherProps } = props;
    return /*#__PURE__*/ jsx(StyledButton, {
        disableRipple: true,
        danger: danger,
        nomarginleft: nomarginleft,
        ...otherProps
    });
}
const SttButton_SttButton = SttButton;
const SttSaveButton = ({ children = 'Salvar', ...props })=>/*#__PURE__*/ jsx(SttButton_SttButton, {
        variant: "contained",
        color: "primary",
        startIcon: /*#__PURE__*/ jsx(Save, {}),
        ...props,
        children: children
    });
const SttButton_SttSaveButton = SttSaveButton;
const SttClearButton = ({ children = 'Limpar', ...props })=>/*#__PURE__*/ jsx(SttButton_SttButton, {
        variant: "outlined",
        color: "primary",
        startIcon: /*#__PURE__*/ jsx(Clear, {}),
        ...props,
        children: children
    });
const SttButton_SttClearButton = SttClearButton;
const SttAddButton_SttAddButton = /*#__PURE__*/ __rspack_external_react.forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(IconButton, {
        ref: ref,
        color: "secondary",
        size: "small",
        ...props,
        children: /*#__PURE__*/ jsx(Add, {})
    });
});
const SttButton_SttAddButton = SttAddButton_SttAddButton;
const StyledTypography = styled(Typography, {
    shouldForwardProp: (prop)=>'required' !== prop
})(({ required })=>({
        '&::after': {
            content: required ? '" *"' : '""'
        }
    }));
const SttHeading = (props)=>/*#__PURE__*/ jsx(StyledTypography, {
        ...props
    });
const SttTypography_SttHeading = SttHeading;
const getFontSizeBySize = (size)=>{
    if ('large' === size) return '1.1rem';
    if ('small' === size) return '0.8rem';
    return '1rem';
};
const SttText = ({ size, sx, ...props })=>/*#__PURE__*/ jsx(Typography, {
        sx: {
            fontSize: getFontSizeBySize(size),
            color: 'text.primary',
            ...sx
        },
        ...props
    });
const SttTypography_SttText = SttText;
const SttInput = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { multiline, rows, sx: sxProps, ...rest } = props;
    return /*#__PURE__*/ jsx(TextField, {
        ...rest,
        inputRef: ref,
        variant: "outlined",
        margin: "dense",
        fullWidth: true,
        multiline: multiline,
        rows: rows,
        sx: {
            '& .MuiInputBase-root': {
                height: multiline ? 'auto' : '40px',
                backgroundColor: '#fff'
            },
            '& .MuiInputLabel-root': {
                color: 'text.secondary',
                lineHeight: multiline ? 'normal' : '40px',
                transform: multiline ? void 0 : 'translate(14px, 0px) scale(1)'
            },
            '& .MuiInputLabel-shrink': {
                transform: 'translate(16px, -14px) scale(0.75)'
            },
            '& .MuiInputLabel-root.Mui-focused': {
                color: 'text.secondary'
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.secondary',
                borderWidth: '1px'
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.secondary',
                borderWidth: '1px'
            },
            '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: 'error.main',
                borderWidth: '2px'
            },
            '& .MuiInputLabel-root.Mui-error': {
                color: 'error.main'
            },
            '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f2f2f2'
            },
            '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                borderColor: '#c2c2c2',
                borderWidth: '2px'
            },
            '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
                WebkitBoxShadow: '0 0 0 1000px #fff inset',
                WebkitTextFillColor: 'inherit',
                transition: 'background-color 9999s ease-in-out 0s'
            },
            ...sxProps
        }
    });
});
const SttInput_SttInput = SttInput;
const SttAutocomplete = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { label, ...other } = props;
    return /*#__PURE__*/ jsx(Autocomplete, {
        noOptionsText: "Sem op\xe7oes dispon\xedveis",
        ...other,
        renderInput: (params)=>/*#__PURE__*/ jsx(SttInput_SttInput, {
                ...params,
                label: label,
                ref: ref,
                sx: {
                    '& .MuiInputBase-root': {
                        height: 'auto',
                        minHeight: '40px',
                        alignItems: 'center',
                        paddingTop: '0 !important',
                        paddingBottom: '0 !important'
                    },
                    '& .MuiChip-root': {
                        height: '24px',
                        alignItems: 'center',
                        marginTop: '10px !important',
                        fontSize: '0.75rem'
                    }
                }
            })
    });
});
const SttInput_SttAutocomplete = SttAutocomplete;
const format = 'DD/MM/YYYY HH:mm:ss';
const SttDateTimePicker = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsx(LocalizationProvider, {
        dateAdapter: AdapterDayjs,
        children: /*#__PURE__*/ jsx(DateTimePicker, {
            ...props,
            inputRef: ref,
            format: format,
            variant: "inline",
            ampm: false,
            inputVariant: "outlined",
            sx: {
                marginTop: 1,
                width: '100%',
                '& .MuiInputBase-root': {
                    height: '40px'
                },
                '& .MuiFormLabel-root': {
                    lineHeight: '40px',
                    transform: 'translate(14px, 0px) scale(1)'
                },
                '& .MuiInputLabel-shrink': {
                    transform: 'translate(16px, -14px) scale(0.75)'
                }
            }
        })
    }));
const SttInput_SttDateTimePicker = SttDateTimePicker;
const localeText = ptBR.components.MuiLocalizationProvider.defaultProps.localeText;
dayjs.extend(updateLocale);
dayjs.updateLocale('pt-br', {
    weekStart: 1
});
const popupSx = (theme)=>({
        '& .MuiPickersToolbar-root': {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 0,
            '& .MuiTypography-root': {
                color: '#fff'
            }
        },
        '& .MuiPickersCalendarHeader-label': {
            color: `${theme.palette.text.primary} !important`
        },
        '& .MuiDayCalendar-weekDayLabel': {
            color: `${theme.palette.text.secondary} !important`
        },
        '& .MuiPickersDay-root': {
            color: `${theme.palette.text.primary} !important`,
            borderRadius: '50% !important'
        },
        '& .MuiPickersDay-root.Mui-disabled': {
            color: `${theme.palette.text.disabled} !important`
        },
        '& .MuiPickersDay-root.Mui-selected': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: '#fff !important'
        }
    });
function SttDatePicker({ sx: sxProps, slotProps, ...props }) {
    return /*#__PURE__*/ jsx(LocalizationProvider, {
        dateAdapter: AdapterDayjs,
        adapterLocale: "pt-br",
        localeText: localeText,
        children: /*#__PURE__*/ jsx(DatePicker, {
            ...props,
            format: "DD/MM/YYYY",
            slotProps: {
                toolbar: {
                    hidden: false,
                    toolbarTitle: ''
                },
                desktopPaper: {
                    sx: popupSx
                },
                ...slotProps
            },
            sx: {
                marginTop: 1,
                width: '100%',
                '& .MuiPickersInputBase-root': {
                    height: '40px',
                    backgroundColor: '#fff'
                },
                '& .MuiPickersInputBase-sectionsContainer': {
                    paddingTop: 0,
                    paddingBottom: 0
                },
                '& .MuiFormLabel-root': {
                    color: 'text.secondary',
                    lineHeight: '40px',
                    transform: 'translate(14px, 0px) scale(1)'
                },
                '& .MuiInputLabel-shrink': {
                    transform: 'translate(16px, -14px) scale(0.75)'
                },
                '& .MuiPickersOutlinedInput-notchedOutline': {
                    borderColor: 'text.secondary',
                    borderWidth: '1px'
                },
                '& .MuiPickersOutlinedInput-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline': {
                    borderColor: (theme)=>`${theme.palette.text.secondary} !important`,
                    borderWidth: '1px'
                },
                '& .MuiFormLabel-root.Mui-focused': {
                    color: (theme)=>`${theme.palette.text.secondary} !important`
                },
                '& .MuiPickersOutlinedInput-root.Mui-error .MuiPickersOutlinedInput-notchedOutline': {
                    borderColor: 'error.main',
                    borderWidth: '2px'
                },
                '& .MuiFormLabel-root.Mui-error': {
                    color: 'error.main'
                },
                ...sxProps
            }
        })
    });
}
const itemBox = {
    flex: 1,
    minWidth: 0,
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    px: 1.5,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    backgroundColor: '#fff',
    color: 'text.secondary',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
const SttListAdd = (props)=>{
    const { value = [], onChange, fields, label, placeholder, disabled = false, allowDuplicates = false, validate, confirmarRemover, getItemLabel, duplicateText = 'Item já adicionado.', invalidText = 'Valor inválido.', error, helperText, sx, ...rest } = props;
    const multi = Array.isArray(fields) && fields.length > 0;
    const campos = multi ? fields : [
        {
            name: 'valor',
            label,
            placeholder,
            validate
        }
    ];
    const entradaVazia = ()=>campos.reduce((acc, c)=>({
                ...acc,
                [c.name]: ''
            }), {});
    const [entrada, setEntrada] = useState(entradaVazia);
    const [erros, setErros] = useState({});
    const setCampo = (name, val)=>{
        setEntrada((atual)=>({
                ...atual,
                [name]: val
            }));
        if (erros[name]) setErros((atual)=>({
                ...atual,
                [name]: ''
            }));
    };
    const adicionar = ()=>{
        const novosErros = {};
        const item = {};
        campos.forEach((c)=>{
            const val = (entrada[c.name] ?? '').trim();
            item[c.name] = val;
            if (c.required && !val) novosErros[c.name] = c.requiredText || 'Campo obrigatório.';
            else if (val && c.validate) {
                const resultado = c.validate(val);
                if (true !== resultado) novosErros[c.name] = 'string' == typeof resultado ? resultado : invalidText;
            }
        });
        if (!campos.some((c)=>item[c.name])) return;
        if (Object.keys(novosErros).length > 0) return void setErros(novosErros);
        const itemFinal = multi ? item : item[campos[0].name];
        const duplicado = !allowDuplicates && value.some((v)=>multi ? JSON.stringify(v) === JSON.stringify(itemFinal) : v === itemFinal);
        if (duplicado) return void setErros({
            [campos[0].name]: duplicateText
        });
        onChange?.([
            ...value,
            itemFinal
        ]);
        setEntrada(entradaVazia());
        setErros({});
    };
    const remover = (index)=>{
        const aplicar = ()=>onChange?.(value.filter((_, i)=>i !== index));
        if (confirmarRemover) confirmarRemover(value[index], aplicar);
        else aplicar();
    };
    const handleKeyDown = (e)=>{
        if ('Enter' === e.key) {
            e.preventDefault();
            adicionar();
        }
    };
    const renderCampo = (c)=>{
        if (c.render) return c.render({
            value: entrada[c.name],
            error: erros[c.name],
            disabled,
            onChange: (value)=>setCampo(c.name, value)
        });
        return /*#__PURE__*/ jsx(SttInput_SttInput, {
            value: entrada[c.name] ?? '',
            label: c.label,
            placeholder: c.placeholder,
            disabled: disabled,
            error: Boolean(error) || Boolean(erros[c.name]),
            helperText: erros[c.name] || (1 === campos.length ? helperText : void 0),
            onChange: (e)=>setCampo(c.name, e.target.value),
            onKeyDown: handleKeyDown
        });
    };
    return /*#__PURE__*/ jsxs(Box, {
        sx: sx,
        ...rest,
        children: [
            /*#__PURE__*/ jsxs(Box, {
                sx: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1
                },
                children: [
                    campos.map((c)=>/*#__PURE__*/ jsx(Box, {
                            sx: {
                                flex: 1,
                                minWidth: 0
                            },
                            children: renderCampo(c)
                        }, c.name)),
                    /*#__PURE__*/ jsx(SttButton_SttAddButton, {
                        onClick: adicionar,
                        disabled: disabled,
                        sx: {
                            mt: 1,
                            height: '40px',
                            width: '40px',
                            flexShrink: 0,
                            bgcolor: 'primary.main',
                            color: '#fff',
                            borderRadius: 1,
                            '&:hover': {
                                bgcolor: 'primary.dark'
                            },
                            '&.Mui-disabled': {
                                bgcolor: 'action.disabledBackground'
                            }
                        }
                    })
                ]
            }),
            value.length > 0 && /*#__PURE__*/ jsx(Box, {
                sx: {
                    mt: 1
                },
                children: value.map((item, index)=>/*#__PURE__*/ jsxs(Box, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            mb: 1
                        },
                        children: [
                            getItemLabel ? /*#__PURE__*/ jsx(Box, {
                                sx: itemBox,
                                children: getItemLabel(item)
                            }) : campos.map((c)=>/*#__PURE__*/ jsx(Box, {
                                    sx: itemBox,
                                    children: multi ? item[c.name] : item
                                }, c.name)),
                            /*#__PURE__*/ jsx(material_IconButton, {
                                color: "primary",
                                disabled: disabled,
                                onClick: ()=>remover(index),
                                sx: {
                                    flexShrink: 0,
                                    width: '40px',
                                    height: '40px'
                                },
                                children: /*#__PURE__*/ jsx(Delete, {})
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const SttInput_SttListAdd = SttListAdd;
const SttTextField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { multiline, rows, sx: sxProps, ...rest } = props;
    return /*#__PURE__*/ jsx(TextField, {
        ...rest,
        inputRef: ref,
        variant: "outlined",
        margin: "dense",
        fullWidth: true,
        multiline: multiline,
        sx: {
            '& .MuiInputBase-root': {
                height: multiline ? 'auto' : '40px'
            },
            '& .MuiInputLabel-root': {
                lineHeight: multiline ? 'normal' : '40px',
                transform: multiline ? void 0 : 'translate(14px, 0px) scale(1)'
            },
            '& .MuiInputLabel-shrink': {
                transform: 'translate(16px, -14px) scale(0.75)'
            },
            ...sxProps
        }
    });
});
const SttInput_SttTextField = SttTextField;
const SttSelect = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { sx: sxProps, children, ...rest } = props;
    return /*#__PURE__*/ jsx(TextField, {
        select: true,
        variant: "outlined",
        fullWidth: true,
        ...rest,
        inputRef: ref,
        sx: {
            '& .MuiInputBase-root': {
                height: '40px',
                alignItems: 'center'
            },
            '& .MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                minHeight: 'unset',
                paddingTop: 0,
                paddingBottom: 0
            },
            '& .MuiInputLabel-root': {
                lineHeight: '40px',
                transform: 'translate(14px, 0px) scale(1)'
            },
            '& .MuiInputLabel-shrink': {
                lineHeight: 'normal',
                transform: 'translate(14px, -8px) scale(0.75)'
            },
            ...sxProps
        },
        children: children
    });
});
const SttInput_SttSelect = SttSelect;
const SttFileUploadNotification = styled(Alert)(({ theme })=>({
        '&.MuiAlert-root': {
            boxShadow: theme.shadows[0],
            backgroundColor: 'rgb(232, 244, 253)'
        }
    }));
const formatarTamanhoArquivoMb = (bytes)=>`${(bytes / 1024 / 1024).toFixed(2)} MB`;
const formatarAccept = (tipos)=>tipos.join(',');
const SttFileUpload = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { value = null, onChange, onBlur, disabled = false, error, accept = [
        '*'
    ], inputId: inputIdProp, multiple = false, placeholder = 'Selecionar arquivo', hint = 'Clique para selecionar um arquivo', infoText, showFileInfo = true, fileInfoPrefix = 'Arquivo:', formatFileSize = formatarTamanhoArquivoMb, uploadIcon: UploadIcon = CloudUpload, infoIcon: InfoIcon = Info, enableDrop = false, sx, inputProps, 'data-testid': dataTestId = 'stt-file-upload' } = props;
    const generatedId = useId();
    const inputId = inputIdProp ?? `stt-file-upload-${generatedId.replace(/:/g, '')}`;
    const possuiErro = Boolean(error);
    const mensagemErro = 'string' == typeof error ? error : void 0;
    const processarArquivos = useCallback((fileList)=>{
        if (!fileList?.length) return;
        onChange?.(multiple ? Array.from(fileList) : fileList[0]);
    }, [
        multiple,
        onChange
    ]);
    const handleInputChange = (event)=>{
        processarArquivos(event.target.files);
        event.target.value = '';
    };
    const handleDragOver = (event)=>{
        if (!enableDrop || disabled) return;
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDrop = (event)=>{
        if (!enableDrop || disabled) return;
        event.preventDefault();
        event.stopPropagation();
        processarArquivos(event.dataTransfer.files);
        onBlur?.();
    };
    const nomeExibido = value ? multiple && Array.isArray(value) ? value.map((arquivo)=>arquivo.name).join(', ') : value.name : placeholder;
    return /*#__PURE__*/ jsxs(Box, {
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ jsx("input", {
                ...inputProps,
                ref: ref,
                accept: formatarAccept(accept),
                style: {
                    display: 'none'
                },
                id: inputId,
                type: "file",
                multiple: multiple,
                onChange: handleInputChange,
                onBlur: onBlur,
                disabled: disabled,
                "data-testid": `${dataTestId}-input`
            }),
            /*#__PURE__*/ jsx("label", {
                htmlFor: inputId,
                children: /*#__PURE__*/ jsxs(Paper, {
                    variant: "outlined",
                    onDragOver: handleDragOver,
                    onDrop: handleDrop,
                    sx: {
                        p: 4,
                        textAlign: 'center',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        border: '2px dashed',
                        borderColor: possuiErro ? 'error.main' : 'divider',
                        backgroundColor: 'transparent',
                        transition: 'all 0.2s',
                        opacity: disabled ? 0.6 : 1,
                        '&.MuiPaper-root': {
                            boxShadow: 'none'
                        },
                        ...!disabled && {
                            '&:hover': {
                                borderColor: 'primary.main',
                                backgroundColor: 'action.hover'
                            }
                        },
                        ...sx
                    },
                    component: "div",
                    "data-testid": `${dataTestId}-dropzone`,
                    children: [
                        /*#__PURE__*/ jsx(UploadIcon, {
                            sx: {
                                fontSize: 48,
                                color: 'text.secondary',
                                mb: 1
                            }
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body1",
                            sx: {
                                fontWeight: 500,
                                mb: 0.5
                            },
                            children: nomeExibido
                        }),
                        hint && /*#__PURE__*/ jsx(Typography, {
                            variant: "caption",
                            color: "text.secondary",
                            children: hint
                        })
                    ]
                })
            }),
            infoText && /*#__PURE__*/ jsxs(Box, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    mt: 1,
                    px: 0.5
                },
                children: [
                    /*#__PURE__*/ jsx(InfoIcon, {
                        sx: {
                            fontSize: 16,
                            color: 'text.secondary'
                        }
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "caption",
                        color: "text.secondary",
                        children: infoText
                    })
                ]
            }),
            showFileInfo && value && !multiple && /*#__PURE__*/ jsxs(SttFileUploadNotification, {
                severity: "info",
                sx: {
                    mt: 2
                },
                "data-testid": `${dataTestId}-file-info`,
                children: [
                    fileInfoPrefix,
                    " ",
                    value.name,
                    " (",
                    formatFileSize(value.size),
                    ")"
                ]
            }),
            showFileInfo && value && multiple && Array.isArray(value) && value.length > 0 && /*#__PURE__*/ jsx(SttFileUploadNotification, {
                severity: "info",
                sx: {
                    mt: 2
                },
                "data-testid": `${dataTestId}-file-info`,
                children: value.map((arquivo)=>/*#__PURE__*/ jsxs(Typography, {
                        variant: "body2",
                        children: [
                            fileInfoPrefix,
                            " ",
                            arquivo.name,
                            " (",
                            formatFileSize(arquivo.size),
                            ")"
                        ]
                    }, arquivo.name))
            }),
            mensagemErro && /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "error",
                sx: {
                    mt: 1,
                    display: 'block'
                },
                "data-testid": `${dataTestId}-error`,
                children: mensagemErro
            })
        ]
    });
});
SttFileUpload.displayName = 'SttFileUpload';
SttFileUpload.propTypes = {
    value: prop_types.oneOfType([
        prop_types.instanceOf(File),
        prop_types.arrayOf(prop_types.instanceOf(File))
    ]),
    onChange: prop_types.func,
    onBlur: prop_types.func,
    disabled: prop_types.bool,
    error: prop_types.oneOfType([
        prop_types.string,
        prop_types.bool
    ]),
    accept: prop_types.arrayOf(prop_types.string),
    inputId: prop_types.string,
    multiple: prop_types.bool,
    placeholder: prop_types.string,
    hint: prop_types.string,
    infoText: prop_types.string,
    showFileInfo: prop_types.bool,
    fileInfoPrefix: prop_types.string,
    formatFileSize: prop_types.func,
    uploadIcon: prop_types.elementType,
    infoIcon: prop_types.elementType,
    enableDrop: prop_types.bool,
    sx: prop_types.object,
    inputProps: prop_types.object,
    'data-testid': prop_types.string
};
const SttFileUpload_SttFileUpload = SttFileUpload;
const ItemLista = styled(ListItem)(({ theme })=>({
        '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: 'white'
        },
        '&.Mui-selected:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white'
        }
    }));
const renderList = (options, open = null, handleClick = null, nested = 'false', index, closeDrawer, disabledItem)=>{
    const { disabled, selected } = options.buttonProps || false;
    let expansion = checkExpansion(options);
    if (options.onClick) handleClick = ()=>{
        options.onClick();
        if (closeDrawer) closeDrawer();
    };
    return /*#__PURE__*/ jsxs("div", {
        children: [
            /*#__PURE__*/ jsxs(ItemLista, {
                button: options.button.toString(),
                disabled: disabled,
                selected: selected || open || expansion,
                onClick: handleClick,
                nested: nested,
                children: [
                    options.icon ? /*#__PURE__*/ jsx(ListItemIcon, {
                        children: /*#__PURE__*/ jsx(options.icon, {})
                    }) : '',
                    /*#__PURE__*/ jsx(ListItemText, {
                        disableTypography: true,
                        primary: /*#__PURE__*/ jsx(Typography, {
                            variant: "h6",
                            children: options.text
                        }),
                        secondary: /*#__PURE__*/ jsx(Typography, {
                            children: options.subtext
                        })
                    }),
                    options.list ? open || expansion ? /*#__PURE__*/ jsx(ExpandLess, {}) : /*#__PURE__*/ jsx(ExpandMore, {}) : ''
                ]
            }),
            options.list ? /*#__PURE__*/ jsx(Collapse, {
                in: open || expansion,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ jsx(SttList, {
                    options: options.list,
                    nested: true,
                    closeDrawer: closeDrawer,
                    disabledItem: disabledItem
                })
            }) : ''
        ]
    }, options.id || options.key || index);
};
const checkExpansion = (options)=>{
    let expansion = false;
    if (options && options.list) {
        const list = options.list;
        list.forEach((element)=>{
            if (element.list) expansion = checkExpansion(element);
            else if (element.buttonProps && element.buttonProps.selected) expansion = true;
        });
    }
    return expansion;
};
const SttList = (props)=>{
    const { options, nested, closeDrawer, disabledItem, ...other } = props;
    const nestedItems = options.filter((element)=>element.list);
    const arr = new Array(nestedItems.length);
    const [listOpen, setOpen] = useState(arr.fill(false));
    const handleClick = (index)=>{
        if (!options[index].list) disabledItem(options[index].id);
        listOpen[index] = !listOpen[index];
        const arr2 = Object.assign([], listOpen);
        setOpen(arr2);
    };
    return /*#__PURE__*/ jsx("div", {
        sx: {
            backgroundColor: 'transparent'
        },
        children: /*#__PURE__*/ jsx(List, {
            component: "nav",
            ...other,
            children: options.map((option, index)=>renderList(option, listOpen[index], ()=>handleClick(index), nested, index, closeDrawer, disabledItem))
        })
    });
};
const lib_SttList = SttList;
const SttDrawer = (props)=>{
    const { open, toggledrawer, closeDrawer } = props;
    const [list, setList] = useState(props.list);
    useEffect(()=>{
        setList(props.list);
    }, [
        props.list
    ]);
    const disabledItem = (id)=>{
        for (let element of list)if (element.list) {
            const newList = newListOption(element.list, id);
            element.list = newList;
        } else if (element.id === id) element.buttonProps.selected = true;
        else element.buttonProps.selected = false;
        setList(list);
    };
    const newListOption = (listOption, id)=>{
        let newList = listOption;
        for (let element of list)if (element.list) {
            const auxList = newListOption(element.list, id);
            element.list = auxList;
        } else if (element.id === id) element.buttonProps.selected = true;
        else element.buttonProps.selected = false;
        return newList;
    };
    return /*#__PURE__*/ jsx("div", {
        children: /*#__PURE__*/ jsx(Drawer, {
            open: open,
            onClose: toggledrawer(),
            children: /*#__PURE__*/ jsx(lib_SttList, {
                options: list,
                closeDrawer: closeDrawer,
                disabledItem: disabledItem
            })
        })
    });
};
const SttNavigation_SttDrawer = SttDrawer;
const StyledIconButton = styled(material_IconButton)(({ theme })=>({
        fontSize: theme.spacing(3),
        color: '#fff',
        margin: 'auto'
    }));
const Menu = styled(Popover)({
    '& .MuiPaper-root': {
        border: '1px solid #d3d4d5',
        height: '250px',
        overflow: 'hidden'
    }
});
const time = new Date().getTime();
function SttMenuModulos({ config }) {
    const [anchor, setAnchor] = react.useState(false);
    const handleClose = ()=>{
        setAnchor(null);
    };
    const handleOpenMenu = (event)=>{
        setAnchor(event.currentTarget);
    };
    return config ? /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(StyledIconButton, {
                disableRipple: true,
                size: "small",
                onClick: handleOpenMenu,
                children: /*#__PURE__*/ jsx(AppsOutlined, {})
            }),
            /*#__PURE__*/ jsx(Menu, {
                anchorEl: anchor,
                keepMounted: true,
                open: Boolean(anchor),
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                children: /*#__PURE__*/ jsx("iframe", {
                    referrerPolicy: "unsafe-url",
                    src: `${config.url_base_oauth2}/MenuModulosManager?moduloAtual=${config.modulo_nome}&v=${time}`,
                    style: {
                        width: '350px',
                        height: '100%',
                        border: 0,
                        position: 'relative'
                    }
                })
            })
        ]
    }) : null;
}
const SttNavigation_SttMenuModulos = SttMenuModulos;
const StyledTab = styled(Tab)(({ theme })=>({
        color: theme.palette.background.default,
        minWidth: 'auto',
        '&.Mui-selected': {
            color: theme.palette.background.default,
            borderBottom: '4px solid'
        },
        '& .MuiTab-wrapper': {
            marginBottom: '-4px'
        }
    }));
const StyledMenu = styled(material_Menu)(({ theme })=>({
        marginTop: theme.spacing(5)
    }));
const StyledTabs = styled(Tabs)(({ theme })=>({
        '& .MuiTabs-flexContainer': {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }));
const SttNavigationBar = ({ submenus, selectedTab = 0, callback = null })=>{
    const [tabSelecionada, selecionarTab] = react.useState(selectedTab);
    const [anchorEl, setAnchorEl] = react.useState(null);
    const [itensMenu, setItensMenu] = react.useState([]);
    const handleOpenMenu = (e, item)=>{
        setAnchorEl(e.currentTarget);
        if (item.list) setItensMenu(item.list);
    };
    const handleMenuClose = ()=>{
        setAnchorEl(null);
        selecionarTab(false);
    };
    const onClickItem = (item, e)=>{
        if (item.list) handleOpenMenu(e, item);
        if (item.onClick) item.onClick();
    };
    useEffect(()=>{
        selecionarTab(selectedTab);
    }, [
        selectedTab
    ]);
    const handleChange = (event, newValue)=>{
        selecionarTab(newValue);
        callback && callback(event, newValue);
    };
    const renderItem = (item, index)=>/*#__PURE__*/ jsx(StyledTab, {
            value: index,
            label: item.text,
            onClick: (e)=>onClickItem(item, e),
            disableRipple: true,
            "aria-controls": "menu"
        }, index);
    const renderItemMenu = (item, index)=>/*#__PURE__*/ jsx(MenuItem, {
            value: index,
            onClick: ()=>{
                if (item.onClick) item.onClick();
                handleMenuClose();
            },
            children: item.text
        }, index);
    return /*#__PURE__*/ jsxs("div", {
        children: [
            /*#__PURE__*/ jsx(StyledTabs, {
                value: tabSelecionada,
                onChange: handleChange,
                variant: "scrollable",
                TabIndicatorProps: {
                    style: {
                        display: 'none'
                    }
                },
                children: submenus.map((item, index)=>renderItem(item, index))
            }),
            /*#__PURE__*/ jsx(StyledMenu, {
                id: "menu",
                onClose: handleMenuClose,
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                children: itensMenu.map((item, index)=>renderItemMenu(item, index))
            })
        ]
    });
};
const SttNavigation_SttNavigationBar = SttNavigationBar;
const StyledDialog = styled(Dialog)(({ theme })=>({
        '& .MuiPaper-root': {
            backgroundColor: theme.palette.common.white,
            borderRadius: theme.spacing(1),
            padding: theme.spacing(1),
            boxShadow: theme.shadows[8]
        }
    }));
const BlurBackground = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(5px)',
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
});
const ICONES = {
    alert: ErrorOutlineOutlined,
    confirmation: HelpOutlineOutlined,
    success: CheckCircleOutlineOutlined,
    error: ErrorOutlineOutlined
};
const CORES_ICONE = {
    alert: orange["800"],
    confirmation: blue["700"],
    success: green["600"],
    error: red["600"]
};
SttAlerta.propTypes = {
    title: prop_types.string,
    message: prop_types.oneOfType([
        prop_types.string,
        prop_types.element
    ]),
    type: prop_types.string,
    options: prop_types.array,
    onClose: prop_types.func,
    open: prop_types.bool,
    blurBackground: prop_types.bool
};
function SttAlerta({ title, message, type = 'alert', options = [], onClose, open, blurBackground }) {
    const Icone = ICONES[type] || ICONES.alert;
    const corIcone = CORES_ICONE[type] || CORES_ICONE.alert;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            open && blurBackground && /*#__PURE__*/ jsx(BlurBackground, {}),
            /*#__PURE__*/ jsxs(StyledDialog, {
                open: open,
                onClose: onClose,
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                children: [
                    /*#__PURE__*/ jsxs(DialogContent, {
                        sx: {
                            pb: 1,
                            maxWidth: "400px",
                            m: 0,
                            p: 1
                        },
                        children: [
                            /*#__PURE__*/ jsx(Box, {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    mb: 1.5
                                },
                                children: /*#__PURE__*/ jsx(Icone, {
                                    sx: {
                                        fontSize: 30,
                                        color: corIcone
                                    }
                                })
                            }),
                            title && /*#__PURE__*/ jsx(Typography, {
                                id: "alert-dialog-title",
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    fontWeight: 600,
                                    fontSize: '1.2rem',
                                    color: '#303031',
                                    mb: 1
                                },
                                children: title
                            }),
                            message && /*#__PURE__*/ jsx(DialogContentText, {
                                id: "alert-dialog-description",
                                sx: {
                                    whiteSpace: 'pre-line',
                                    fontSize: '0.875rem',
                                    color: '#303031'
                                },
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(DialogActions, {
                        sx: {
                            pt: 0
                        },
                        children: options.map((option, index)=>/*#__PURE__*/ jsx(SttButton_SttButton, {
                                onClick: ()=>option.onClick(option.params),
                                variant: option.variant || (0 === index ? 'contained' : 'outlined'),
                                color: option.color,
                                disabled: option.disabled,
                                children: option.title
                            }, index))
                    })
                ]
            })
        ]
    });
}
const ClosabeTabLabel = (props)=>{
    const { title, handleClose, index } = props;
    return /*#__PURE__*/ jsx(material_IconButton, {
        disableRipple: true,
        size: "small",
        onClick: (event)=>{
            event.stopPropagation();
            handleClose(title, index);
        }
    });
};
const EditableTabLabel = (props)=>{
    const { title, handleEdit, index } = props;
    return /*#__PURE__*/ jsx(material_IconButton, {
        disableRipple: true,
        size: "small",
        onClick: (event)=>{
            event.stopPropagation();
            handleEdit(title, index);
        }
    });
};
const SttTabs = (props)=>{
    const { abas, abaAtiva, handleChangeAbaAtiva, errors, canClose = false, handleCloseTab, canEdit = false, handleEditTab, permanente, preload = true } = props;
    const [value, setValue] = react.useState(abaAtiva || '0');
    const [removerAba, setRemoverAba] = react.useState(false);
    const [msgRemoverAba, setMsgRemoverAba] = react.useState('');
    const [opcoesRemoverAba, setOpcoesRemoverAba] = react.useState([]);
    const handleChange = (event, newValue)=>{
        setValue(newValue);
        if (handleChangeAbaAtiva) handleChangeAbaAtiva(newValue);
    };
    useEffect(()=>{
        if (abaAtiva) setValue(abaAtiva);
    }, [
        abaAtiva
    ]);
    useEffect(()=>{
        if (1 === abas.length || abas.length == value) setValue('0');
    }, [
        abas
    ]);
    const preCloseTab = (titulo, indice)=>{
        setMsgRemoverAba(`Você deseja realmente fechar a aba "${titulo}"?`);
        setRemoverAba(true);
        const opcoes = [
            {
                title: "Sim",
                onClick: (params)=>{
                    handleCloseTab(params);
                    setRemoverAba(false);
                },
                params: [
                    indice
                ]
            },
            {
                title: "Não",
                onClick: ()=>setRemoverAba(false)
            }
        ];
        setOpcoesRemoverAba(opcoes);
    };
    const createLabel = (aba, indice)=>/*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("span", {
                    children: aba.titulo
                }),
                canEdit && /*#__PURE__*/ jsx(EditableTabLabel, {
                    title: aba.titulo,
                    index: indice,
                    handleEdit: handleEditTab
                }),
                canClose && !aba.permanente && /*#__PURE__*/ jsx(ClosabeTabLabel, {
                    title: aba.titulo,
                    index: indice,
                    handleClose: preCloseTab
                })
            ]
        });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(TabContext, {
                value: value,
                children: [
                    /*#__PURE__*/ jsx(Tabs, {
                        onChange: handleChange,
                        value: value,
                        variant: "scrollable",
                        scrollButtons: "auto",
                        children: abas.map((aba, indice)=>/*#__PURE__*/ jsx(Tab, {
                                component: "div",
                                disabled: aba.disabled,
                                label: createLabel(aba, indice),
                                disableRipple: true,
                                style: {
                                    maxWidth: '300px',
                                    color: errors && (aba.key && errors[aba.key] || !aba.key && errors[indice]) ? '#F5222D' : ''
                                },
                                onClick: aba.handleClick || null,
                                value: indice.toString()
                            }, aba.key || aba.idAba || aba.id || indice))
                    }),
                    abas.map((aba, indice)=>{
                        const { conteudo, key, ...other } = aba;
                        const Conteudo = conteudo;
                        let Panel = TabPanel;
                        const panelValue = indice.toString();
                        if (indice == value) aba.carregada = true;
                        return /*#__PURE__*/ jsx(Panel, {
                            value: panelValue,
                            children: preload || aba.carregada ? /*#__PURE__*/ jsx(Conteudo, {
                                ...other
                            }) : null
                        }, key || aba.idAba || aba.id || indice);
                    })
                ]
            }),
            /*#__PURE__*/ jsx(SttAlerta, {
                open: removerAba,
                title: "Aten\xe7\xe3o",
                message: msgRemoverAba,
                type: "alert",
                options: opcoesRemoverAba,
                onClose: ()=>setRemoverAba(false)
            })
        ]
    });
};
SttTabs.propTypes = {
    abas: prop_types.arrayOf(prop_types.shape({
        titulo: prop_types.string.isRequired,
        conteudo: prop_types.elementType.isRequired,
        handleClick: prop_types.func,
        permanente: prop_types.bool
    })).isRequired,
    preload: prop_types.bool,
    canClose: prop_types.bool,
    permanente: prop_types.bool
};
const SttNavigation_SttTabs = SttTabs;
const StyledTableCell = styled(TableCell)(({ theme })=>({
        paddingTop: '10px',
        paddingBottom: '10px',
        '&.MuiTableCell-head': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
            fontWeight: 'bold',
            color: theme.palette.secondary.main
        }
    }));
function SttTableCell(props) {
    return /*#__PURE__*/ jsx(StyledTableCell, {
        ...props
    });
}
const SttTable_SttTableCell = SttTableCell;
const StyledTableSortLabel = styled(TableSortLabel)(({ theme })=>({
        color: `${theme.palette.primary.main} !important`,
        '& .MuiTableSortLabel-icon': {
            color: `${theme.palette.primary.main} !important`
        }
    }));
function SttTableSortLabel(props) {
    return /*#__PURE__*/ jsx(StyledTableSortLabel, {
        ...props,
        IconComponent: Sort
    });
}
const SttTable_SttTableSortLabel = SttTableSortLabel;
const Descricao = ({ children })=>{
    const theme = useTheme();
    const dispositivoTouch = useMediaQuery(theme.breakpoints.down('lg'));
    const [open, setOpen] = useState(false);
    const handleClick = ()=>{
        if (dispositivoTouch) setOpen((prev)=>!prev);
    };
    const handleHover = (newState)=>{
        if (!dispositivoTouch) setOpen(newState);
    };
    useEffect(()=>{
        setOpen(false);
    }, [
        dispositivoTouch
    ]);
    return /*#__PURE__*/ jsx(Tooltip, {
        title: children,
        open: open,
        disableTouchListener: !dispositivoTouch,
        children: /*#__PURE__*/ jsx(Help, {
            sx: {
                fontSize: '0.8rem',
                verticalAlign: 'super',
                color: 'primary.main'
            },
            ...dispositivoTouch && {
                onClick: handleClick
            },
            onMouseEnter: ()=>handleHover(true),
            onMouseLeave: ()=>handleHover(false)
        })
    });
};
Descricao.propTypes = {
    children: prop_types.node
};
const Description = Descricao;
const SttModal_StyledDialog = styled(Dialog)(({ theme })=>({
        '& .MuiDialog-paper': {
            backgroundColor: theme.palette.common.white,
            borderRadius: theme.spacing(1),
            boxShadow: theme.shadows[8]
        }
    }));
const StyledDialogTitle = styled(DialogTitle)(({ theme })=>({
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: theme.spacing(2, 3),
        position: 'relative',
        borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(0)
    }));
const TitleText = styled(SttTypography_SttHeading)(({ theme })=>({
        color: theme.palette.common.white,
        fontWeight: theme.typography.fontWeightBold
    }));
const StyledDialogContent = styled(DialogContent, {
    shouldForwardProp: (prop)=>'contentDividers' !== prop
})(({ theme, contentDividers })=>({
        backgroundColor: theme.palette.common.white,
        padding: theme.spacing(1),
        ...contentDividers && {
            '& > *': {
                borderBottom: `1px solid ${theme.palette.divider}`,
                padding: theme.spacing(2, 0)
            },
            '& > *:last-child': {
                borderBottom: 'none'
            }
        }
    }));
const StyledDialogActions = styled(DialogActions)(({ theme })=>({
        position: 'relative',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        backgroundColor: theme.palette.common.white,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: theme.spacing(3),
            right: theme.spacing(3),
            height: 1,
            backgroundColor: theme.palette.divider
        },
        '& .stt-cancel, & [data-role="cancel"]': {
            color: theme.palette.error.main
        },
        '& .stt-cancel.MuiButton-contained, & [data-role="cancel"].MuiButton-contained': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
            '&:hover': {
                backgroundColor: darken(theme.palette.error.main, 0.08)
            }
        },
        '& .stt-cancel.MuiButton-outlined, & [data-role="cancel"].MuiButton-outlined': {
            borderColor: theme.palette.error.main,
            color: theme.palette.error.main,
            '&:hover': {
                borderColor: darken(theme.palette.error.main, 0.08)
            }
        }
    }));
const StyledCloseButton = styled(material_IconButton)(({ theme })=>({
        position: 'absolute',
        right: theme.spacing(1.5),
        top: theme.spacing(1.5),
        color: theme.palette.common.white
    }));
const HeaderExtra = styled('div')(({ theme })=>({
        marginTop: theme.spacing(2)
    }));
SttModal.propTypes = {
    title: prop_types.string,
    children: prop_types.node,
    footer: prop_types.node,
    outModalClose: prop_types.func,
    iconClose: prop_types.func,
    open: prop_types.bool.isRequired,
    contentDividers: prop_types.bool,
    headerExtra: prop_types.node
};
function SttModal(props) {
    const { outModalClose, title, iconClose, children, footer, open = false, contentDividers = false, headerExtra, ...other } = props;
    return /*#__PURE__*/ jsxs(SttModal_StyledDialog, {
        open: open,
        onClose: outModalClose,
        ...other,
        children: [
            title && /*#__PURE__*/ jsxs(StyledDialogTitle, {
                disableTypography: true,
                children: [
                    /*#__PURE__*/ jsx(TitleText, {
                        variant: "h2",
                        color: "inherit",
                        children: title
                    }),
                    iconClose && /*#__PURE__*/ jsx(StyledCloseButton, {
                        "aria-label": "close",
                        onClick: iconClose,
                        children: /*#__PURE__*/ jsx(Close, {})
                    }),
                    headerExtra && /*#__PURE__*/ jsx(HeaderExtra, {
                        children: headerExtra
                    })
                ]
            }),
            /*#__PURE__*/ jsx(StyledDialogContent, {
                contentDividers: contentDividers,
                children: children
            }),
            footer && /*#__PURE__*/ jsx(StyledDialogActions, {
                children: footer
            })
        ]
    });
}
const lib_SttModal = SttModal;
const MateriaisSuporte = (props)=>{
    const { strings, headers, config, open, setOpen } = props;
    const [materiais, setMateriais] = useState([]);
    const UTILITARIOS_API_BASE_URL = config.url_base_utilitarios;
    useEffect(()=>{
        axios.get(`${UTILITARIOS_API_BASE_URL}/materiais`, {
            headers: headers,
            params: {
                modulo: config.modulo_sigla
            }
        }).then((response)=>{
            if (response) setMateriais(response.data);
        }).catch((err)=>console.log(err));
        const messageListener = (e)=>{
            const { acao } = e.data;
            if ('ABRIR_MATERIAL_SUPORTE' === acao) setOpen(true);
        };
        window.addEventListener('message', messageListener);
        return ()=>{
            window.removeEventListener('message', messageListener);
        };
    }, []);
    const visualizar = (nome, url)=>{
        axios.get(url, {
            headers: headers,
            responseType: 'blob'
        }).then((response)=>{
            const anchorElement = document.createElement('a');
            document.body.appendChild(anchorElement);
            anchorElement.style.display = 'none';
            const blob = new Blob([
                response.data
            ], {
                type: 'application/pdf'
            });
            const fileURL = URL.createObjectURL(blob);
            anchorElement.href = fileURL;
            anchorElement.target = '_blank';
            anchorElement.click();
            document.body.removeChild(anchorElement);
        }).catch((err)=>console.log(err));
    };
    const handleCloseModal = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ jsx(lib_SttModal, {
        title: strings.materiaisSuporte,
        open: open,
        outModalClose: handleCloseModal,
        maxWidth: "lg",
        fullWidth: true,
        iconClose: handleCloseModal,
        sx: {
            overflowY: 'auto'
        },
        children: /*#__PURE__*/ jsx(Grid, {
            container: true,
            spacing: 2,
            sx: {
                padding: 2
            },
            children: materiais.map((item)=>/*#__PURE__*/ jsx(Grid, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 2,
                    children: /*#__PURE__*/ jsxs(Card, {
                        sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100%',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ jsx(CardActionArea, {
                                sx: {
                                    textAlign: 'center'
                                },
                                disableRipple: true,
                                onClick: ()=>visualizar(item.nome, item.url),
                                children: /*#__PURE__*/ jsx("img", {
                                    src: item.thumbnail
                                })
                            }),
                            /*#__PURE__*/ jsx(Typography, {
                                sx: {
                                    textAlign: 'center'
                                },
                                children: item.nome
                            }),
                            /*#__PURE__*/ jsx(Typography, {
                                sx: {
                                    textAlign: 'center'
                                },
                                children: item.data
                            }),
                            /*#__PURE__*/ jsx("img", {
                                src: item.qrCode
                            })
                        ]
                    })
                }, item.id))
        }),
        footer: /*#__PURE__*/ jsx("div", {
            children: /*#__PURE__*/ jsx(SttButton_SttButton, {
                variant: "contained",
                onClick: handleCloseModal,
                children: "Fechar"
            })
        })
    });
};
MateriaisSuporte.propTypes = {
    strings: prop_types.object.isRequired,
    config: prop_types.object.isRequired,
    headers: prop_types.object.isRequired,
    open: prop_types.bool.isRequired,
    setOpen: prop_types.func.isRequired
};
const lib_MateriaisSuporte = MateriaisSuporte;
function SttLoading(props) {
    const { open, text, progress } = props;
    return /*#__PURE__*/ jsx(Dialog, {
        open: open,
        children: /*#__PURE__*/ jsxs(Container, {
            sx: {
                display: 'flex',
                padding: [
                    3,
                    4,
                    3
                ],
                alignItems: 'center'
            },
            children: [
                progress ? /*#__PURE__*/ jsx(CircularProgress, {
                    variant: "determinate",
                    value: progress
                }) : /*#__PURE__*/ jsx(CircularProgress, {}),
                text && /*#__PURE__*/ jsx(Typography, {
                    sx: {
                        paddingLeft: 3
                    },
                    children: text
                })
            ]
        })
    });
}
SttLoading.propTypes = {
    open: prop_types.bool,
    text: prop_types.string
};
const lib_SttLoading = SttLoading;
const StyledStepper = styled(Stepper)(({ theme })=>({
        color: theme.palette.common.white,
        backgroundColor: 'transparent',
        padding: 0,
        '& .MuiStepLabel-root': {
            color: theme.palette.common.white
        },
        '& .MuiStepLabel-labelContainer': {
            color: theme.palette.common.white,
            '& .Mui-active': {
                color: theme.palette.common.white,
                fontWeight: theme.typography.fontWeightBold
            },
            '& .Mui-completed': {
                color: theme.palette.common.white
            }
        },
        '& .MuiStepIcon-root': {
            color: theme.palette.common.white,
            '&.Mui-active': {
                color: theme.palette.common.white
            },
            '&.Mui-completed': {
                color: theme.palette.common.white
            }
        },
        '& .MuiStepIcon-text': {
            fill: theme.palette.primary.main
        },
        '& .MuiStepConnector-root': {
            '& .MuiStepConnector-line': {
                borderColor: theme.palette.common.white
            }
        }
    }));
SttModalStepper.propTypes = {
    title: prop_types.string,
    children: prop_types.node,
    footer: prop_types.node,
    outModalClose: prop_types.func,
    iconClose: prop_types.func,
    open: prop_types.bool.isRequired,
    contentDividers: prop_types.bool,
    steps: prop_types.arrayOf(prop_types.string).isRequired,
    activeStep: prop_types.number.isRequired
};
SttModalStepper.defaultProps = {
    open: false,
    contentDividers: false
};
function SttModalStepper(props) {
    const { steps, activeStep, ...other } = props;
    return /*#__PURE__*/ jsx(lib_SttModal, {
        ...other,
        headerExtra: /*#__PURE__*/ jsx(StyledStepper, {
            activeStep: activeStep,
            children: steps.map((label)=>/*#__PURE__*/ jsx(Step, {
                    children: /*#__PURE__*/ jsx(StepLabel, {
                        children: label
                    })
                }, label))
        })
    });
}
const lib_SttModalStepper = SttModalStepper;
function SttCreateButton(props) {
    return /*#__PURE__*/ jsx(SttButton_SttButton, {
        ...props,
        type: props.type || "button",
        variant: props.variant || "outlined",
        color: props.color || "primary",
        size: props.size || "medium",
        onClick: props.onClick || null,
        startIcon: /*#__PURE__*/ jsx(Add, {}),
        disabled: props.disabled || false,
        nomarginleft: props.nomarginleft || "true",
        children: props.children || props.descricao || 'Cadastrar'
    });
}
const SttButton_SttCreateButton = SttCreateButton;
function SttSelectButton(props) {
    return /*#__PURE__*/ jsx(SttButton_SttButton, {
        ...props,
        type: props.type || "button",
        variant: props.selected ? "contained" : "outlined",
        color: props.color || "primary",
        onClick: props.onClick || null,
        endIcon: props.selected && /*#__PURE__*/ jsx(IconButton, {
            "aria-label": "home",
            onClick: (e)=>{
                e.stopPropagation();
                props.onClear && props.onClear(e);
            },
            children: /*#__PURE__*/ jsx(ClearOutlined, {
                style: {
                    color: '#ECFEDB'
                }
            })
        }),
        disabled: props.disabled,
        nomarginleft: props.nomarginleft || void 0,
        children: 'function' == typeof props.children ? props.children() : props.children
    });
}
const SttButton_SttSelectButton = SttSelectButton;
function SttVisualizadoresButton({ visualizadores = [], style = {} }) {
    const [open, setOpen] = useState(false);
    const boxRef = useRef(null);
    const alternador = ()=>setOpen(!open);
    useEffect(()=>{
        function handleClickOutside(event) {
            if (boxRef.current && !boxRef.current.contains(event.target)) setOpen(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ jsxs(Box, {
        ref: boxRef,
        sx: {
            position: 'relative',
            display: 'inline-block'
        },
        children: [
            /*#__PURE__*/ jsx(SttButton_SttButton, {
                type: "button",
                variant: "outlined",
                color: "primary",
                size: "medium",
                startIcon: /*#__PURE__*/ jsx(PanTool, {}),
                endIcon: /*#__PURE__*/ jsx(ArrowDropDown, {}),
                onClick: alternador,
                style: {
                    ...style
                },
                children: "Visualizadores"
            }),
            open && /*#__PURE__*/ jsx(Box, {
                sx: {
                    mt: 1,
                    p: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    bgcolor: 'white',
                    boxShadow: 3,
                    borderRadius: '8px',
                    zIndex: 10,
                    position: 'absolute',
                    width: 'max-content',
                    minWidth: '200px'
                },
                children: visualizadores.map((item, index)=>/*#__PURE__*/ jsx(SttButton_SttButton, {
                        type: "button",
                        variant: item.variant || "outlined",
                        color: item.color || "primary",
                        size: "small",
                        startIcon: item.icon ? /*#__PURE__*/ jsx(item.icon, {}) : null,
                        onClick: ()=>{
                            setOpen(false);
                            item.onClick?.();
                        },
                        style: {
                            justifyContent: 'center',
                            textTransform: 'none',
                            marginBottom: '4px',
                            marginLeft: -3,
                            ...item.style
                        },
                        children: item.descricao
                    }, index))
            })
        ]
    });
}
const SttVisualisadoresButton = SttVisualizadoresButton;
const getButton = (btn, index, actionButton)=>{
    const botaoCustonizado = btn.custom?.style || {};
    if (btn.cadastrar) return /*#__PURE__*/ createElement(SttButton_SttCreateButton, {
        ...btn,
        style: botaoCustonizado,
        key: index
    });
    if (btn.salvar) return /*#__PURE__*/ createElement(SttButton_SttSaveButton, {
        ...btn,
        style: botaoCustonizado,
        key: index
    });
    if (btn.limpar) return /*#__PURE__*/ createElement(SttButton_SttClearButton, {
        ...btn,
        style: botaoCustonizado,
        key: index
    });
    if (btn.visualizador) return /*#__PURE__*/ jsx(SttVisualisadoresButton, {
        visualizadores: btn.visualizadores,
        style: botaoCustonizado
    }, index);
    if (btn.selecao) return /*#__PURE__*/ createElement(SttButton_SttSelectButton, {
        ...btn,
        style: botaoCustonizado,
        key: index
    });
    return /*#__PURE__*/ jsx(SttButton_SttButton, {
        type: btn.type || "button",
        variant: actionButton ? "outlined" : btn.variant || "outlined",
        color: btn.color || "primary",
        size: btn.size || "medium",
        startIcon: btn.icon ? /*#__PURE__*/ jsx(btn.icon, {}) : null,
        disabled: btn.disabled || false,
        nomarginleft: btn.nomarginleft || "true",
        danger: btn.danger || void 0,
        onClick: btn.onClick || null,
        style: botaoCustonizado,
        children: btn.descricao
    }, index);
};
const getButtonAcoes = (btn, index)=>{
    const botaoCustonizado = btn.custom?.style || {};
    const styleAcoes = {
        textTransform: 'none',
        justifyContent: 'flex-start',
        padding: '8px 12px',
        color: '#757575',
        marginLeft: 0,
        ...botaoCustonizado
    };
    btn.color = 'inherit';
    btn.variant = 'text';
    btn.size = 'medium';
    if (btn.cadastrar) return /*#__PURE__*/ createElement(SttButton_SttCreateButton, {
        ...btn,
        style: styleAcoes,
        key: index
    });
    if (btn.salvar) return /*#__PURE__*/ createElement(SttButton_SttSaveButton, {
        ...btn,
        style: styleAcoes,
        key: index
    });
    if (btn.limpar) return /*#__PURE__*/ createElement(SttButton_SttClearButton, {
        ...btn,
        style: styleAcoes,
        key: index
    });
    if (btn.visualizador) return /*#__PURE__*/ jsx(SttVisualisadoresButton, {
        visualizadores: btn.visualizadores,
        style: styleAcoes
    }, index);
    if (btn.selecao) return /*#__PURE__*/ createElement(SttButton_SttSelectButton, {
        ...btn,
        style: styleAcoes,
        key: index
    });
    return /*#__PURE__*/ jsx(Button, {
        type: btn.type || "button",
        disabled: btn.disabled || false,
        danger: btn.danger || false,
        onClick: btn.onClick || null,
        startIcon: btn.icon ? /*#__PURE__*/ jsx(btn.icon, {}) : null,
        color: btn.color || "inherit",
        variant: btn.variant || "text",
        size: btn.size || "medium",
        style: styleAcoes,
        children: btn.descricao
    }, index);
};
const SttContainerTitle = (props)=>{
    const { botoes, botaoAcoes, onClickVoltar, titulo } = props;
    const numeroBotoes = botoes ? botoes.filter((item)=>item.show).length : 0;
    const [mostrarBotoes, setMostrarBotoes] = useState(false);
    useEffect(()=>{
        function handleClickOutside(event) {
            if (mostrarBotoes && !document.getElementById('menu-botoes')?.contains(event.target)) setMostrarBotoes(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        mostrarBotoes
    ]);
    return /*#__PURE__*/ jsxs(Grid, {
        container: true,
        sx: (theme)=>({
                mt: 0.5,
                mb: 1,
                pb: 1,
                borderBottom: `3px solid ${theme.palette.primary.main}`,
                borderRadius: '2px'
            }),
        children: [
            /*#__PURE__*/ jsxs(Grid, {
                size: {
                    xs: 'grow',
                    sm: 10
                },
                sx: {
                    display: 'flex',
                    alignItems: 'center'
                },
                children: [
                    onClickVoltar && /*#__PURE__*/ jsx(material_IconButton, {
                        color: "primary",
                        disableRipple: true,
                        size: "small",
                        onClick: onClickVoltar,
                        children: /*#__PURE__*/ jsx(ArrowBackIos, {})
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "h1",
                        color: "primary",
                        sx: {
                            display: 'inline-block',
                            textAlign: 'left'
                        },
                        children: titulo
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Grid, {
                size: {
                    xs: 'auto',
                    sm: 2
                },
                children: botoes ? numeroBotoes > 1 ? /*#__PURE__*/ jsxs(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        gap: 1,
                        pb: 0.5
                    },
                    onBlur: (e)=>{
                        if (!e.currentTarget.contains(e.relatedTarget)) setMostrarBotoes(false);
                    },
                    children: [
                        /*#__PURE__*/ jsx(SttButton_SttButton, {
                            nomarginleft: true,
                            style: {
                                width: 100
                            },
                            color: "primary",
                            "aria-haspopup": "true",
                            variant: "outlined",
                            onClick: ()=>setMostrarBotoes(!mostrarBotoes),
                            startIcon: mostrarBotoes ? /*#__PURE__*/ jsx(ArrowDropUp, {}) : /*#__PURE__*/ jsx(ArrowDropDown, {}),
                            children: "A\xe7\xf5es"
                        }),
                        mostrarBotoes && /*#__PURE__*/ jsx(Box, {
                            id: "menu-botoes",
                            sx: {
                                position: 'absolute',
                                margin: '50px 0 0 0',
                                zIndex: 1000
                            },
                            children: /*#__PURE__*/ jsx(Paper, {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column'
                                },
                                children: botoes?.map((btn, index)=>btn.show && getButtonAcoes(btn, index))
                            })
                        })
                    ]
                }) : /*#__PURE__*/ jsx(Box, {
                    sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: 1,
                        pb: 0.5
                    },
                    children: botoes?.map((btn, index)=>btn.show && getButton(btn, index))
                }) : null
            })
        ]
    });
};
const lib_SttContainerTitle = SttContainerTitle;
function SttNotificationScreen(props) {
    const { strings, headers, config, perfisRBAC = [] } = props;
    const [open, setOpen] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [salvando, setSalvando] = useState(false);
    const [ehAdmin] = useState(perfisRBAC.some((p)=>p.identificador.includes('admin')));
    const handleCloseAlerta = ()=>{
        setMostrarAlerta(false);
    };
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [tituloAlerta, setTituloAlerta] = useState(strings.sucesso);
    const [tipoAlerta, setTipoAlerta] = useState('success');
    const [mensagemAlerta, setMensagemAlerta] = useState(strings.sucesso);
    const [onCloseAlerta, setOnCloseAlerta] = useState(()=>handleCloseAlerta);
    const [opcoesAlerta, setOpcoesAlerta] = useState([
        {
            title: strings.ok,
            onClick: handleCloseAlerta
        }
    ]);
    useEffect(()=>{
        listarNotificacoes();
    }, []);
    function listarNotificacoes() {
        axios.get(`${config.url_base_mensagens}/notificacao-usuario?modulo=${config.modulo_sigla}`, {
            headers: headers
        }).then((response)=>{
            if (response.data.data) {
                const notific = response.data.data;
                if (notific.totalRegistros > 0) {
                    setNotificacoes(notific.itens);
                    setOpen(true);
                    return;
                }
                setOpen(false);
            }
        }).catch((err)=>console.log(err));
    }
    function handleCloseModal() {
        setOpen(false);
    }
    function confirmarLeitura() {
        const mensagensLidas = [];
        notificacoes.forEach((n)=>{
            if (n.lida) mensagensLidas.push(n._id);
        });
        setSalvando(true);
        axios.post(`${config.url_base_mensagens}/notificacao-leitura`, {
            mensagensLidas
        }, {
            headers: headers
        }).then((response)=>{
            setTipoAlerta('success');
            setTituloAlerta(strings.sucesso);
            setMensagemAlerta(response.data.message);
            setOpcoesAlerta([
                {
                    title: strings.ok,
                    onClick: ()=>{
                        listarNotificacoes();
                        setMostrarAlerta(false);
                    }
                }
            ]);
            setOnCloseAlerta(()=>()=>{
                    listarNotificacoes();
                    setMostrarAlerta(false);
                });
            setMostrarAlerta(true);
        }).catch((err)=>console.log(err)).finally(()=>{
            setSalvando(false);
        });
    }
    function desabilitarConfirmarLeitura() {
        return notificacoes.every((n)=>!n.lida);
    }
    function handleClick(event) {
        if ('a' === event.target.tagName.toLowerCase()) {
            window.open(event.target.href, '_blank');
            event.preventDefault();
        }
    }
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SttAlerta, {
                open: mostrarAlerta,
                title: tituloAlerta,
                message: mensagemAlerta,
                type: tipoAlerta,
                options: opcoesAlerta,
                onClose: onCloseAlerta
            }),
            /*#__PURE__*/ jsx(lib_SttLoading, {
                open: salvando
            }),
            /*#__PURE__*/ jsx(lib_SttModal, {
                title: strings.notificacoes,
                open: open,
                maxWidth: "lg",
                fullWidth: true,
                children: /*#__PURE__*/ jsx(Fragment, {
                    children: notificacoes && notificacoes.length > 0 && notificacoes.map((n, index)=>/*#__PURE__*/ jsx("div", {
                            children: /*#__PURE__*/ jsx(Card, {
                                variant: "outlined",
                                sx: {
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                    marginBottom: 1
                                },
                                children: /*#__PURE__*/ jsxs(CardContent, {
                                    children: [
                                        /*#__PURE__*/ jsx(Typography, {
                                            variant: "h3",
                                            sx: {
                                                marginBottom: 0.5,
                                                marginTop: 1
                                            },
                                            color: "primary",
                                            children: n.envio.assunto
                                        }),
                                        /*#__PURE__*/ jsx("div", {
                                            onClick: handleClick,
                                            sx: {
                                                overflow: 'auto',
                                                marginBottom: 0.5,
                                                marginLeft: 0.5
                                            },
                                            children: /*#__PURE__*/ jsx("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: n.envio.conteudo
                                                }
                                            })
                                        }),
                                        n.envio.bloqueioTela && !ehAdmin ? /*#__PURE__*/ jsxs(Alert, {
                                            severity: "warning",
                                            children: [
                                                strings.atencao,
                                                "!\xa0",
                                                strings.avisoMensagemBloqueia
                                            ]
                                        }) : /*#__PURE__*/ jsx(FormControlLabel, {
                                            required: true,
                                            control: /*#__PURE__*/ jsx(Checkbox, {
                                                color: "primary",
                                                checked: !!n.lida,
                                                onChange: (evt, value)=>{
                                                    notificacoes[index].lida = evt.target.checked;
                                                    setNotificacoes([
                                                        ...notificacoes
                                                    ]);
                                                }
                                            }),
                                            label: strings.liCiente
                                        })
                                    ]
                                })
                            })
                        }, index))
                }),
                footer: /*#__PURE__*/ jsxs("div", {
                    children: [
                        /*#__PURE__*/ jsx(SttButton_SttButton, {
                            variant: "contained",
                            onClick: confirmarLeitura,
                            disabled: desabilitarConfirmarLeitura(),
                            children: strings.confirmarLeitura
                        }),
                        (!notificacoes.some((n)=>n.envio.leituraObrigatoria || n.envio.bloqueioTela) || ehAdmin) && /*#__PURE__*/ jsx(SttButton_SttButton, {
                            variant: "contained",
                            onClick: handleCloseModal,
                            children: strings.fechar
                        })
                    ]
                })
            })
        ]
    });
}
const lib_SttNotificationScreen = SttNotificationScreen;
const juntarClasses = (...classes)=>classes.filter(Boolean).join(' ');
const SttSection = ({ children, className = '', contentClassName = '', headerClassName = '', icon = null, title, titleProps = {}, ...paperProps })=>{
    const { className: titleClassName, ...otherTitleProps } = titleProps;
    return /*#__PURE__*/ jsxs(Paper, {
        variant: "outlined",
        ...paperProps,
        className: juntarClasses('stt-section', className, paperProps.className),
        children: [
            title && /*#__PURE__*/ jsxs(Box, {
                className: juntarClasses('stt-section-header', headerClassName),
                children: [
                    icon && /*#__PURE__*/ jsx(Box, {
                        className: "stt-section-icon",
                        children: icon
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        component: "span",
                        variant: "subtitle2",
                        ...otherTitleProps,
                        className: juntarClasses(titleClassName),
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                className: contentClassName,
                children: children
            })
        ]
    });
};
const SttSection_SttSection = SttSection;
const SttSplashScreen_Container = material_styled(Box)(({ theme })=>({
        padding: theme.spacing(2)
    }));
function SttSplashScreen(props) {
    const { modulo, versao, novidades, textoAjuda, open, setOpen, perfisRBAC } = props;
    function handleCloseModal() {
        setOpen(false);
    }
    useEffect(()=>{
        if (!perfisRBAC || 0 === perfisRBAC.length) return;
        if (!perfisRBAC.some((p)=>'administrador' === p.identificador)) return;
        const moduloVersao = `stt-${modulo}-${versao}`;
        const storageLS = localStorage.getItem(moduloVersao);
        const storageCookie = js_cookie.get(moduloVersao);
        if (!storageLS && !storageCookie) {
            localStorage.setItem(moduloVersao, true);
            js_cookie.set(moduloVersao, 'true');
            setOpen(true);
        }
    }, [
        perfisRBAC
    ]);
    return /*#__PURE__*/ jsx(lib_SttModal, {
        title: "Notas de atualiza\xe7\xe3o",
        open: open,
        outModalClose: handleCloseModal,
        maxWidth: "lg",
        fullWidth: true,
        iconClose: handleCloseModal,
        children: /*#__PURE__*/ jsxs(SttSplashScreen_Container, {
            children: [
                /*#__PURE__*/ jsxs(SttTypography_SttHeading, {
                    variant: "h2",
                    color: "primary",
                    children: [
                        'STT 2 - M\xf3dulo "',
                        modulo,
                        '" vers\xe3o ',
                        versao
                    ]
                }),
                /*#__PURE__*/ jsx("br", {}),
                /*#__PURE__*/ jsx(SttTypography_SttHeading, {
                    variant: "h3",
                    color: "primary",
                    children: "Novidades:"
                }),
                novidades && novidades.length > 0 && novidades.map((n, index)=>/*#__PURE__*/ jsxs("div", {
                        children: [
                            /*#__PURE__*/ jsx("br", {}),
                            /*#__PURE__*/ jsxs(SttTypography_SttHeading, {
                                variant: "h5",
                                color: "initial",
                                children: [
                                    "- ",
                                    n
                                ]
                            })
                        ]
                    }, index)),
                textoAjuda && /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx("br", {}),
                        /*#__PURE__*/ jsx("br", {}),
                        /*#__PURE__*/ jsx("br", {}),
                        /*#__PURE__*/ jsx(SttTypography_SttHeading, {
                            variant: "h4",
                            color: "initial",
                            children: textoAjuda
                        })
                    ]
                })
            ]
        }),
        footer: /*#__PURE__*/ jsx("div", {
            children: /*#__PURE__*/ jsx(SttButton_SttButton, {
                variant: "contained",
                onClick: handleCloseModal,
                children: "Fechar"
            })
        })
    });
}
SttSplashScreen.propTypes = {
    modulo: prop_types.string,
    versao: prop_types.string,
    novidades: prop_types.array
};
const lib_SttSplashScreen = SttSplashScreen;
const StyledSwitch = styled(({ cor, ...props })=>/*#__PURE__*/ jsx(Switch, {
        focusVisibleClassName: ".Mui-focusVisible",
        disableRipple: true,
        ...props
    }))(({ theme, cor })=>({
        '&&': {
            width: 37,
            height: 23,
            padding: 0,
            display: 'inline-flex',
            position: 'relative'
        },
        '& .MuiSwitch-switchBase': {
            position: 'absolute',
            top: 0,
            left: 0,
            padding: 1,
            color: '#fff',
            '&:hover, &.Mui-checked:hover': {
                backgroundColor: 'transparent'
            },
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: cor || theme.palette.primary.main,
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: theme.palette.primary.main,
                border: '5px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 19,
            height: 19,
            marginTop: 1
        },
        '& .MuiSwitch-track': {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            borderRadius: 11,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            boxSizing: 'border-box',
            transition: theme.transitions.create([
                'background-color'
            ], {
                duration: 500
            })
        }
    }));
const StyledFormControlLabel = styled(material_FormControlLabel)(({ theme })=>({
        marginLeft: 0,
        marginRight: 0,
        gap: theme.spacing(1.5),
        '& .MuiFormControlLabel-label': {
            fontSize: '0.9rem',
            color: theme.palette.text.primary
        },
        '&.Mui-disabled .MuiFormControlLabel-label': {
            color: theme.palette.text.disabled
        }
    }));
function SttSwitch(props) {
    const { label, labelPlacement, sx, className, checked, defaultChecked, onChange, ...switchProps } = props;
    const isControlled = void 0 !== checked;
    const [internalChecked, setInternalChecked] = react.useState(Boolean(defaultChecked));
    const currentChecked = isControlled ? checked : internalChecked;
    const handleChange = (event, value)=>{
        if (!isControlled) setInternalChecked(value);
        onChange?.(event, value);
    };
    const control = /*#__PURE__*/ jsx(StyledSwitch, {
        checked: currentChecked,
        onChange: handleChange,
        sx: label ? void 0 : sx,
        className: label ? void 0 : className,
        ...switchProps
    });
    if (label) {
        const resolvedLabel = 'function' == typeof label ? label(currentChecked) : label;
        return /*#__PURE__*/ jsx(StyledFormControlLabel, {
            control: control,
            label: resolvedLabel,
            labelPlacement: labelPlacement,
            sx: sx,
            className: className
        });
    }
    return control;
}
const lib_SttSwitch = SttSwitch;
const estilos = {
    descricao: {
        fontWeight: 700,
        fontSize: {
            xs: 14,
            sm: 16
        },
        marginBottom: 1,
        wordBreak: 'break-word'
    },
    data: {
        fontSize: {
            xs: 11,
            sm: '1rem'
        },
        color: 'text.secondary',
        marginTop: 1.25,
        whiteSpace: 'nowrap',
        marginLeft: 2
    },
    detalhes: {
        fontSize: {
            xs: 12,
            sm: 13
        },
        maxWidth: '80%',
        wordBreak: 'break-word'
    }
};
const formatarData = (date)=>moment(date).format('DD/MM/YYYY HH:mm:ss');
const SttTimeLine = ({ props })=>{
    const { dados, config } = props;
    return /*#__PURE__*/ jsx(Timeline, {
        align: "left",
        sx: {
            '&& .MuiTimelineItem-root::before': {
                flex: 0,
                padding: 0,
                margin: 0
            }
        },
        children: dados.map((item, idx)=>{
            const CorConfig = config[item.status];
            return /*#__PURE__*/ jsxs(TimelineItem, {
                children: [
                    /*#__PURE__*/ jsxs(TimelineSeparator, {
                        children: [
                            /*#__PURE__*/ jsx(TimelineDot, {
                                sx: {
                                    width: 8,
                                    height: 8,
                                    padding: 0,
                                    background: (theme)=>CorConfig?.cor || theme.palette.primary.main,
                                    boxShadow: (theme)=>`0 0 0 3px ${theme.palette.common.white}, 0 0 0 5px ${CorConfig?.cor || theme.palette.primary.main}`,
                                    color: (theme)=>alpha(theme.palette.primary.main, 0.3)
                                }
                            }),
                            idx < dados.length - 1 && /*#__PURE__*/ jsx(TimelineConnector, {
                                sx: {
                                    minHeight: 50
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(TimelineContent, {
                        children: /*#__PURE__*/ jsxs("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start'
                            },
                            children: [
                                /*#__PURE__*/ jsxs("div", {
                                    children: [
                                        item.descricao && /*#__PURE__*/ jsx(SttTypography_SttText, {
                                            sx: estilos.descricao,
                                            children: item.descricao
                                        }),
                                        /*#__PURE__*/ jsx(SttTypography_SttText, {
                                            sx: estilos.detalhes,
                                            children: /*#__PURE__*/ jsx("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: item.detalhes
                                                }
                                            })
                                        })
                                    ]
                                }),
                                item.data && /*#__PURE__*/ jsx(SttTypography_SttText, {
                                    component: "span",
                                    sx: estilos.data,
                                    children: formatarData(item.data)
                                })
                            ]
                        })
                    })
                ]
            }, idx);
        })
    });
};
const SttTimeline = SttTimeLine;
export { Description, SttAlerta, SttButton_SttAddButton as SttAddButton, SttButton_SttButton as SttButton, SttButton_SttClearButton as SttClearButton, SttButton_SttSaveButton as SttSaveButton, SttDatePicker, SttFileUpload_SttFileUpload as SttFileUpload, SttInput_SttAutocomplete as SttAutocomplete, SttInput_SttDateTimePicker as SttDateTimePicker, SttInput_SttInput as SttInput, SttInput_SttListAdd as SttListAdd, SttInput_SttSelect as SttSelect, SttInput_SttTextField as SttTextField, SttNavigation_SttDrawer as SttDrawer, SttNavigation_SttMenuModulos as SttMenuModulos, SttNavigation_SttNavigationBar as SttNavigationBar, SttNavigation_SttTabs as SttTabs, SttSection_SttSection as SttSection, SttTable_SttTableCell as SttTableCell, SttTable_SttTableSortLabel as SttTableSortLabel, SttTimeline, SttTypography_SttHeading as SttHeading, SttTypography_SttText as SttText, formatarAccept, formatarTamanhoArquivoMb, lib_MateriaisSuporte as MateriaisSuporte, lib_SttContainerTitle as SttContainerTitle, lib_SttList as SttList, lib_SttLoading as SttLoading, lib_SttModal as SttModal, lib_SttModalStepper as SttModalStepper, lib_SttNotificationScreen as SttNotificationScreen, lib_SttSplashScreen as SttSplashScreen, lib_SttSwitch as SttSwitch, src_theme_theme as SttTheme, theme_SttThemeProvider as SttThemeProvider, theme_baseThemeOptions as baseThemeOptions, theme_themeEbserh as SttThemeEbserh };
